import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['creditnotes']);

  return (
    <>
      <Header.Root>
        <Header.Content backTo={routes.creditNotes} title={t('creditnotes:create.title')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('creditnotes:create.error.title')} />
      </Container>
    </>
  );
};
